import React, { memo } from "react";
import { CouponConfetti, TradeDiscountSuccessCard } from "@swiggy-private/cart-types";
import { CartModal } from "@swiggy-private/cart-ui";
import { ThemeProvider } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider";
import { SnaccTheme } from "@swiggy-private/dls-web-common/dist/components/themes/Snacc";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

interface FreebiePopupProps {
    data: TradeDiscountSuccessCard;
    closeModal: () => void;
    showCouponConfetti: boolean;
    triggerConfettiByType: (type: CouponConfetti) => void;
}

const FreebiePopup: React.FC<FreebiePopupProps> = ({ data, closeModal, showCouponConfetti, triggerConfettiByType }) => {
    useEffectOnce(() => {
        if (!isEmpty(data) && showCouponConfetti) {
            triggerConfettiByType?.(CouponConfetti.AUTO_APPLY);
        }
    });

    return (
        <ThemeProvider theme={SnaccTheme} colorMode="light">
            <CartModal
                data={{
                    title: data.subtitle?.toUpperCase(),
                    text: data.savings,
                    icon: data.logo_id,
                    description: "",
                    cta: {
                        isCustomCTA: true,
                        text: "YAY",
                        color: "primary_Accent",
                        textColor: "background_Add_Button",
                    },
                }}
                closeModal={closeModal}
            />
        </ThemeProvider>
    );
};

export default memo(FreebiePopup);
